import React from 'react'
import './style.css'

import Paper from 'material-ui/Paper'
import FontAwesome from 'react-fontawesome'

const EmptyAgendas = ({ props }) => (
  <Paper className="EmptyAgendas">
    <p>Você ainda não controla uma agenda</p>
    <FontAwesome name="frown-o" size="4x" />
  </Paper>
)
export default EmptyAgendas



// WEBPACK FOOTER //
// ./src/components/EmptyAgendas/index.js